import React, { useEffect, useMemo, useState } from 'react';
import './index.css';
import styled from '@emotion/styled';
import { ReactComponent as FilesIcon } from 'common/icons/files.svg';
import { ReactComponent as ContactsIcon } from 'common/icons/contacts.svg';
import { ReactComponent as ClockIcon } from 'common/icons/clock-big.svg';
import { ReactComponent as StarIcon } from 'common/icons/star.svg';
import { ReactComponent as TrashIcon } from 'common/icons/trash-alt.svg';
import { LinearProgress, useTheme } from '@mui/material';
import { ReactComponent as CloudIcon } from 'common/icons/cloud.svg';
import SearchInput from 'common/components/SearchInput';
import { ReactComponent as PlusIcon } from 'common/icons/plus.svg';
import { ReactComponent as FileDownload } from './icons/file-download.svg';
import { ReactComponent as FolderDownload } from './icons/folder-download.svg';
import { ReactComponent as DottedMenuIcon } from 'common/icons/dotted-menu.svg';
import { ReactComponent as TableGridIcon } from 'common/icons/table-grid.svg';
import { ReactComponent as InfoIcon } from 'common/icons/info.svg';
import { ReactComponent as VerticalDots } from 'common/icons/dots-vertical.svg';
// import { ReactComponent as FileIcon } from 'common/icons/file.svg';
import { useSearchParams } from 'react-router-dom';
import SelectEl from 'common/components/Select';
import Avatar1 from './images/avatar1.jpg';
import Avatar2 from './images/avatar2.jpg';
import Avatar3 from './images/avatar3.jpg';
import Avatar4 from './images/avatar4.jpg';

const MoreButton = styled.button`
    background: ${(props) => props.theme.colors.secondaryColor};
    color: ${(props) => props.theme.colors.primaryTextColor};
    border: 1px solid ${(props) => props.theme.colors.gray};
    padding: 0 12px 0 8px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 8px;
    font-family: Mulish;
    font-size: 16px;
    font-style: normal;
    cursor: pointer;
    font-weight: 300;
    gap: 12px;
    line-height: 100%;
    letter-spacing: 1px;
    transition: 0.5s;
    &:hover {
        background: ${(props) => props.theme.colors.secondaryHoverColor};
        color: ${(props) => props.theme.colors.primaryTextColor};
        border: 1px solid ${(props) => props.theme.colors.primaryColor};
    }
`;
const MoreButtonDropdown = styled.div`
  padding: 6px 0px;
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid ${(props) => props.theme.colors.gray};
  background-color: ${(props) => props.theme.colors.secondaryColor};
  position: absolute;
  top: 58px;
  right: 0;
`;

const MoreButtonDropdownItem = styled.div`
  display:flex;
  gap: 12px;
  align-items: center;
  padding: 6px 20px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  &:hover {
    background-color: ${(props) => props.theme.colors.primaryColor + '1A'};
  }
  &:active {
    background-color: ${(props) => props.theme.colors.primaryColor + '40'};
  }
`;

const MoreButtonSeparator = styled.div`
    width:100%;
    height:1px;
    background-color: ${(props) => props.theme.colors.gray};
    margin-top: 10px;
    margin-bottom: 10px;
`;


const SidebarWrapper = styled.div`
    display:flex;
    flex-direction: column;
    border-radius: 16px;
    border: 1px solid ${(props) => props.theme.colors.gray};
    position: relative;
    padding: 13px 0;
    width:100%;
    overflow: hidden;
`;

const Separator = styled.div`
    width:100%;
    height:1px;
    background-color: ${(props) => props.theme.colors.gray};
    margin-top: 12px;
    margin-bottom: 12px;
`;

const SidebarItem = styled.div`
    display:flex;
    gap: 12px;
    padding: 8px 16px;
    align-items: center;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    &:hover {
        // .1 opacity
        background-color: ${(props) => props.theme.colors.primaryColor + '1A'};
    }
    &.active {
        // .25 opacity
        background-color: ${(props) => props.theme.colors.primaryColor + '40'};
    }
    &.disabled {
        cursor: default;
        padding: 0;
    }
    &.disabled:hover {
        background-color: transparent;
    }
`;

const TypeSelectData = [
  {
    label: 'Тип',
    value: 1,
  },
];
const UserSelectData = [
  {
    label: 'Люди',
    value: 1,
  },
];
const ChangesSelectData = [
  {
    label: 'Зміни',
    value: 1,
  },
];

type FileItemProps = {
  id: string | number,
  name: string,
  owner: {
    id: string | number,
    name: string,
    avatar: string,
  },
  lastChanges: string,
  size: string,
};

const generateMockFiles = (count: number) => {
  const owners = [
    {
      id: 1,
      name: 'Я',
      avatar: Avatar1,
    },
    {
      id: 2,
      name: 'Анабель',
      avatar: Avatar2,
    },
    {
      id: 3,
      name: 'Вікторія',
      avatar: Avatar3,
    },
    {
      id: 4,
      name: 'Ян',
      avatar: Avatar4,
    },
  ];
  const dates = ['15.11.2023', '12.11.2023', '08.11.2023', '24.10.2023'];
  const sizes = ['-', '1,4 гб', '6,7 мб', '1,2 мб'];
  const mockList = [];
  for (let i = 0; i < count; i++) {
    const randomOwner = owners[Math.floor(Math.random() * owners.length)];
    const randomDate = dates[Math.floor(Math.random() * dates.length)];
    const randomSize = sizes[Math.floor(Math.random() * sizes.length)];
    mockList.push({
      id: i,
      name: `Файл${i}`,
      owner: randomOwner,
      lastChanges: `${randomDate}, ${randomOwner.name}`,
      size: randomSize,
    });
  }
  return mockList;
};

const FileItemWrapper = styled.div`
    display:flex;
    align-items: center;
    height: 40px;
    border-radius: 8px;
    padding: 8px 0;
    background-color: transparent;
    transition: all 0.2s ease-in-out;
    flex-shrink: 0;
    cursor: pointer;
    user-select: none;
    &:hover {
        background-color: ${(props) => props.theme.colors.primaryColor + '1A'};
    }
    &.active {
        background-color: ${(props) => props.theme.colors.primaryColor + '40'};
    }
`;

const FileItem = ({ name, owner, lastChanges, size, onClick, id, selected }: FileItemProps & { selected:boolean, onClick: (id: string | number) => void }) => {
  const theme = useTheme();
  return (
        <FileItemWrapper onClick={()=>{onClick(id);}} className={`files-list-item-wrapper${selected && ' active'}`}>
            <div className='files-list-item'>
                <div className='files-list-item-container'>
                    <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
                        <path fillRule="evenodd" clipRule="evenodd" d="M8.90479 3.66675H6.80746C6.25177 3.66675 5.71883 3.8875 5.3259 4.28043C4.93297 4.67336 4.71222 5.20629 4.71222 5.76199V16.2382C4.71222 16.7939 4.93297 17.3268 5.3259 17.7197C5.71883 18.1127 6.25177 18.3334 6.80746 18.3334H15.1884C15.7441 18.3334 16.277 18.1127 16.67 17.7197C17.0629 17.3268 17.2836 16.7939 17.2836 16.2382L17.2857 7.85722L13.0953 3.66675" stroke={theme.colors.black} strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                    <span className='files-list-item-text'>{name}</span>
                </div>
            </div>
            <div className='files-list-item'>
                <div className='files-list-item-container'>
                    <img src={owner.avatar} alt='avatar' className='files-list-item-avatar' />
                    <span className='files-list-item-text'>{owner.name}</span>
                </div>
            </div>
            <div className='files-list-item'>
                <div className='files-list-item-container'>
                    <span className='files-list-item-text'>{lastChanges}</span>
                </div>
            </div>
            <div className='files-list-item'>
                <div className='files-list-item-container'>
                    <span className='files-list-item-text'>{size}</span>
                    <VerticalDots className='svg-black svg-button' style={{ marginLeft: 'auto' }} />
                </div>
            </div>
        </FileItemWrapper>
  );
};

export default function FilesPage() {
  const theme = useTheme();
  const [modalMore, setModalMore] = useState(false);
  const [fileList] = useMemo(() => {
    return [generateMockFiles(20)];
  }, [20]);
  const [selectValues, setSelectValues] = useState({
    type: 1,
    user: 1,
    changes: 1,
  });

  const handleSelectChange = (e) => {
    const { name, value } = e.target;
    setSelectValues((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const closeModalMore = (e: MouseEvent) => {
    if (!(e.target as HTMLElement).closest('.order-more-button-container')) {
      setModalMore(false);
    }
  };
  const [searchParams, setSearchParams] = useSearchParams();
  const type = searchParams.get('type');

  const changeType = (value: string) => {
    if (value === '') {
      searchParams.delete('type');
      setSearchParams(searchParams);
      return;
    }
    searchParams.set('type', value);
    setSearchParams(searchParams);
  };

  // close modalMore on click outside
  useEffect(() => {
    if (modalMore) {
      document.addEventListener('click', closeModalMore);
    }
    return () => {
      document.removeEventListener('click', closeModalMore);
    };
  }, [modalMore]);

  // handle selected file change
  const [selectedFile, setSelectedFile] = useState(null);
  const handleFileClick = (id: string | number) => {
    if (selectedFile === id) {
      console.log('open file');
    } else {
      setSelectedFile(id);
    }
  };

  return (
        <div className='files-section'>
            <div className='files-wrapper'>
                <h2 className='new-h2'>Файли</h2>
                <div className='files-content'>
                    <div className='files-sidebar-wrapper'>
                        <SidebarWrapper>
                            <SidebarItem className={(type === '' || !type) ? 'active' : ''} onClick={() => { changeType(''); }}>
                                <FilesIcon className='svg-black' />
                                <p className='new-p'>Всі файли</p>
                            </SidebarItem>
                            <Separator />
                            <SidebarItem className={type === 'available' ? 'active' : ''} onClick={() => { changeType('available'); }}>
                                <ContactsIcon className='svg-black' />
                                <p className='new-p'>Доступні файли</p>
                            </SidebarItem>
                            <SidebarItem className={type === 'recent' ? 'active' : ''} onClick={() => { changeType('recent'); }}>
                                <ClockIcon className='svg-black svg-fill' />
                                <p className='new-p'>Нещодавні</p>
                            </SidebarItem>
                            <SidebarItem className={type === 'favorites' ? 'active' : ''} onClick={() => { changeType('favorites'); }}>
                                <StarIcon className='svg-black' />
                                <p className='new-p'>Обрані</p>
                            </SidebarItem>
                            <Separator />
                            <SidebarItem className={type === 'spam' ? 'active' : ''} onClick={() => { changeType('spam'); }}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <g id="ri:spam-line">
                                        <path id="Vector" d="M11 15H13V17H11V15ZM11 7H13V13H11V7Z" fill={theme.colors.black} />
                                        <circle id="Ellipse 144" cx="12" cy="12" r="9.25" stroke={theme.colors.black} strokeWidth="1.5" />
                                    </g>
                                </svg>

                                <p className='new-p'>Спам</p>
                            </SidebarItem>
                            <SidebarItem className={type === 'trash' ? 'active' : ''} onClick={() => { changeType('trash'); }}>
                                <TrashIcon className='svg-black' />
                                <p className='new-p'>Кошик</p>
                            </SidebarItem>
                        </SidebarWrapper>
                        <div className='files-sidebar-storage-wrapper'>
                            <SidebarItem className='disabled'>
                                <CloudIcon className='svg-black svg-fill' />
                                <p className='new-p'>Хранилище</p>
                            </SidebarItem>
                            <div className='files-sidebar-storage-progress'>
                                <LinearProgress variant='determinate' value={52} sx={{
                                  backgroundColor: theme.colors.gray + '40',
                                }} />
                            </div>
                            <span className='files-sidebar-storage-text gray-text'>
                                Використано 7,35 ГБ из 15 Гб
                            </span>
                        </div>
                    </div>
                    <div className='files-main-wrapper'>
                        <div className='files-search-wrapper'>
                            <SearchInput wrapperStyle={{ flex: '1 0 auto' }} placeholder='Пошук...' />
                            <div className='order-more-button-container'>
                                <MoreButton onClick={() => { setModalMore(true); }}>
                                    <PlusIcon className='svg-black' />
                                    <span>Зберегти як</span>
                                </MoreButton>
                                {modalMore &&
                                    <MoreButtonDropdown onClick={(e) => { e.stopPropagation(); }}>
                                        <MoreButtonDropdownItem>
                                            <FilesIcon height={16} width={16} className='svg-black' />
                                            <span className='order-more-button-text'>Створити папку</span>
                                        </MoreButtonDropdownItem>
                                        <MoreButtonSeparator />
                                        <MoreButtonDropdownItem>
                                            <FileDownload height={16} width={16} className='svg-black' />
                                            <span className='order-more-button-text'>Завантажити файл</span>
                                        </MoreButtonDropdownItem>
                                        <MoreButtonDropdownItem>
                                            <FolderDownload height={16} width={16} className='svg-black' />
                                            <span className='order-more-button-text'>Завантажити папку</span>
                                        </MoreButtonDropdownItem>
                                    </MoreButtonDropdown>
                                }
                            </div>
                        </div>
                        <div className='files-top-line'>
                            <span className='big-text'>Файли</span>
                            <div className='files-top-line-buttons'>
                                <DottedMenuIcon className='svg-black svg-button active' />
                                <TableGridIcon className='svg-black svg-button' />
                                <InfoIcon className='svg-black svg-fill svg-button' />
                            </div>
                        </div>
                        <div className='files-select-wrapper'>
                            <SelectEl data={TypeSelectData} value={selectValues.type} onChange={handleSelectChange} name='type' />
                            <SelectEl data={UserSelectData} value={selectValues.user} onChange={handleSelectChange} name='user' />
                            <SelectEl data={ChangesSelectData} value={selectValues.changes} onChange={handleSelectChange} name='changes' />
                        </div>
                        <div className='files-list-header'>
                            <span className='gray-text'>Назва</span>
                            <span className='gray-text'>Власник</span>
                            <span className='gray-text'>Останні зміни</span>
                            <span className='gray-text'>Розмір файла</span>
                        </div>
                        <div className='files-list-wrapper'>
                            <div className='files-list u-fancy-scrollbar'>
                                {fileList.map((item: FileItemProps) => (
                                    <FileItem onClick={handleFileClick} key={item.id} {...item} selected={selectedFile === item.id} />
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
  );
}